function detectInputType() {
	var domCount = document.getElementsByTagName('*').length;
	// only enabled with DOM node count under 10,000
	// if used with large node counts, performance is not good
	if (domCount < 10000) {
		// detect input type
		var body = document.querySelector('body');
		if (body) {
			document.addEventListener(
				'keyup',
				function (e) {
					// ignore modifier keys, like shift and control
					if ([16, 17, 18, 91, 93].indexOf(e.which) === -1) {
						body.setAttribute('data-whatinput', 'keyboard');
					}
				},
				false
			);
			document.addEventListener(
				'mousedown',
				function (e) {
					body.setAttribute('data-whatinput', 'mouse');
				},
				false
			);
			document.addEventListener(
				'touchstart',
				function (e) {
					body.setAttribute('data-whatinput', 'touch');
				},
				false
			);
		}
	}
}

document.addEventListener('lichen:loaded', detectInputType);

export default detectInputType;
